import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'lucide-react';

const Header = ({ onDemoClick }) => {
  return (
    <header className="bg-slate-900 border-b border-slate-700 h-14 flex items-center justify-between px-4 shrink-0">
      <div className="flex items-center gap-2">
        <Container className="text-blue-500" size={24} />
        <h1 className="font-bold text-lg tracking-wide">Docker Log Inspector</h1>
      </div>
      <div className="flex gap-3">
        <button
          onClick={onDemoClick}
          className="text-xs text-slate-400 hover:text-white underline"
        >
          Load Demo Data
        </button>
      </div>
    </header>
  );
};

Header.propTypes = {
  onDemoClick: PropTypes.func.isRequired
};

export default Header;

